// Tag Workspace theme selection (light-only). The chosen palette is applied as
// a `theme-*` class on every `.tag-scope` wrapper so shadcn tokens pick it up.
// A `?theme=` query param selects/persists a palette for review; otherwise the
// default below is used.
const DEFAULT_TAG_THEME = 'lavender';
const ALLOWED = ['lavender', 'bluepink', 'notes'];

export function tagThemeClass() {
  try {
    const p = new URLSearchParams(window.location.search).get('theme');
    if (p && ALLOWED.includes(p)) sessionStorage.setItem('tag_theme', p);
    const t = (p && ALLOWED.includes(p))
      ? p
      : (sessionStorage.getItem('tag_theme') || DEFAULT_TAG_THEME);
    return `theme-${ALLOWED.includes(t) ? t : DEFAULT_TAG_THEME}`;
  } catch {
    return `theme-${DEFAULT_TAG_THEME}`;
  }
}
